<template>
  <div class="af">
    <!-- Navbar -->
    <nav class="af-nav">
      <div class="af-nav__inner">
        <div class="af-nav__logo">
          <router-link to="/"><img src="/logo-booster.png" alt="VSLBooster" class="af-nav__logo-img" /></router-link>
        </div>
        <div class="af-nav__links">
          <a href="/#funcionalidades" class="af-nav__link">Funcionalidades</a>
          <a href="/#precos" class="af-nav__link">Precos</a>
          <router-link to="/blog" class="af-nav__link">Blog</router-link>
        </div>
        <div class="af-nav__actions">
          <router-link to="/login" class="af-nav__link">Entrar</router-link>
        </div>
      </div>
    </nav>

    <!-- Hero -->
    <section class="af-hero">
      <div class="af-hero__content">
        <div class="af-hero__badge">Programa de Afiliados</div>
        <h1 class="af-hero__title">Ganhe <span>30%</span> de comissao recorrente indicando o VSLBooster</h1>
        <p class="af-hero__sub">Indique a plataforma #1 de Video Sales Letters do Brasil e receba comissoes todo mes enquanto seu indicado for cliente.</p>
        <div class="af-hero__stats">
          <div class="af-hero__stat">
            <div class="af-hero__stat-value">30%</div>
            <div class="af-hero__stat-label">Comissao recorrente</div>
          </div>
          <div class="af-hero__stat">
            <div class="af-hero__stat-value">90 dias</div>
            <div class="af-hero__stat-label">Cookie de atribuicao</div>
          </div>
          <div class="af-hero__stat">
            <div class="af-hero__stat-value">R$0</div>
            <div class="af-hero__stat-label">Para comecar</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Benefits -->
    <section class="af-benefits">
      <div class="af-container">
        <h2 class="af-section-title">Por que ser afiliado VSLBooster?</h2>
        <div class="af-benefits__grid">
          <div class="af-benefit" v-for="b in benefits" :key="b.title">
            <div class="af-benefit__icon">{{ b.icon }}</div>
            <h3 class="af-benefit__title">{{ b.title }}</h3>
            <p class="af-benefit__desc">{{ b.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- How it works -->
    <section class="af-how">
      <div class="af-container">
        <h2 class="af-section-title">Como funciona</h2>
        <div class="af-how__steps">
          <div class="af-step" v-for="(s, i) in steps" :key="i">
            <div class="af-step__num">{{ i + 1 }}</div>
            <h3 class="af-step__title">{{ s.title }}</h3>
            <p class="af-step__desc">{{ s.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Form -->
    <section class="af-form-section" id="cadastro">
      <div class="af-container">
        <div class="af-form-grid">
          <div class="af-form-info">
            <h2 class="af-form-info__title">Cadastre-se como afiliado</h2>
            <p class="af-form-info__sub">Preencha o formulario e nossa equipe vai avaliar sua candidatura em ate 48 horas.</p>
            <div class="af-form-info__checks">
              <div class="af-check" v-for="c in checks" :key="c"><span class="af-check__icon">&#10003;</span> {{ c }}</div>
            </div>
          </div>

          <div class="af-form-card">
            <div v-if="!done">
              <div class="af-field">
                <label class="af-label">Nome completo</label>
                <input v-model="form.name" class="af-input" placeholder="Seu nome" />
              </div>
              <div class="af-field">
                <label class="af-label">Email</label>
                <input v-model="form.email" type="email" class="af-input" placeholder="seu@email.com" />
              </div>
              <div class="af-field">
                <label class="af-label">WhatsApp</label>
                <input v-model="form.phone" type="tel" class="af-input" placeholder="(11) 99999-9999" />
              </div>
              <div class="af-field">
                <label class="af-label">Instagram ou site</label>
                <input v-model="form.social" class="af-input" placeholder="@seu_perfil ou https://seusite.com" />
              </div>
              <div class="af-field">
                <label class="af-label">Qual seu nicho de atuacao?</label>
                <select v-model="form.niche" class="af-input">
                  <option value="">Selecione...</option>
                  <option value="infoprodutos">Infoprodutos / Cursos</option>
                  <option value="afiliado">Afiliado Digital</option>
                  <option value="agencia">Agencia / Trafego Pago</option>
                  <option value="social_media">Social Media / Influencer</option>
                  <option value="consultoria">Consultoria / Mentoria</option>
                  <option value="ecommerce">E-commerce</option>
                  <option value="outro">Outro</option>
                </select>
              </div>
              <div class="af-field">
                <label class="af-label">Tamanho da sua audiencia</label>
                <select v-model="form.audience_size" class="af-input">
                  <option value="">Selecione...</option>
                  <option value="0-1k">Ate 1.000 seguidores</option>
                  <option value="1k-10k">1.000 a 10.000</option>
                  <option value="10k-50k">10.000 a 50.000</option>
                  <option value="50k-100k">50.000 a 100.000</option>
                  <option value="100k+">Mais de 100.000</option>
                </select>
              </div>
              <div class="af-field">
                <label class="af-label">Por que quer ser afiliado VSLBooster? <span class="af-optional">(opcional)</span></label>
                <textarea v-model="form.motivation" class="af-input af-textarea" rows="3" placeholder="Conte um pouco sobre voce e como pretende divulgar..."></textarea>
              </div>

              <div v-if="erro" class="af-erro">{{ erro }}</div>

              <button class="af-btn" @click="submit" :disabled="loading">
                {{ loading ? 'Enviando...' : 'Quero ser afiliado' }}
              </button>

              <p class="af-privacy">Seus dados estao seguros. Nao compartilhamos com terceiros.</p>
            </div>

            <div v-else class="af-success">
              <div class="af-success__icon">&#127881;</div>
              <h3 class="af-success__title">Cadastro recebido!</h3>
              <p class="af-success__text">Obrigado pelo interesse! Nossa equipe vai analisar sua candidatura e entrar em contato em ate 48 horas pelo email <strong>{{ form.email }}</strong>.</p>
              <router-link to="/blog" class="af-btn af-btn--ghost">Conhecer o Blog</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ -->
    <section class="af-faq">
      <div class="af-container">
        <h2 class="af-section-title">Perguntas frequentes</h2>
        <div class="af-faq__list">
          <div class="af-faq__item" v-for="(faq, i) in faqs" :key="i" @click="faqOpen === i ? faqOpen = -1 : faqOpen = i">
            <div class="af-faq__q">
              <span>{{ faq.q }}</span>
              <span class="af-faq__arrow" :class="{ 'af-faq__arrow--open': faqOpen === i }">&#9662;</span>
            </div>
            <div v-show="faqOpen === i" class="af-faq__a">{{ faq.a }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="af-footer">
      <div class="af-container af-footer__inner">
        <img src="/logo-booster.png" alt="VSLBooster" style="height:30px;opacity:0.7" />
        <span>&copy; {{ new Date().getFullYear() }} VSLBooster. Todos os direitos reservados.</span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AfiliadosCadastro',
  metaInfo: {
    title: 'Programa de Afiliados | VSLBooster — Ganhe 30% de Comissao Recorrente',
    titleTemplate: '%s',
    meta: [
      { name: 'description', content: 'Seja afiliado VSLBooster e ganhe 30% de comissao recorrente. Indique a plataforma #1 de Video Sales Letters do Brasil. Cadastre-se gratis.' },
      { property: 'og:title', content: 'Programa de Afiliados VSLBooster — 30% Recorrente' },
      { property: 'og:description', content: 'Ganhe comissoes recorrentes indicando o VSLBooster. Cookie de 90 dias, materiais prontos e suporte dedicado.' },
    ],
    link: [{ rel: 'canonical', href: 'https://vslbooster.com/afiliados' }],
  },
  data() {
    return {
      form: { name: '', email: '', phone: '', social: '', niche: '', audience_size: '', motivation: '' },
      loading: false,
      erro: '',
      done: false,
      faqOpen: -1,
      benefits: [
        { icon: '💰', title: 'Comissao recorrente de 30%', desc: 'Receba todo mes enquanto seu indicado for assinante. Nao e so na primeira venda.' },
        { icon: '🍪', title: 'Cookie de 90 dias', desc: 'Se alguem clicar no seu link e comprar em ate 90 dias, a comissao e sua.' },
        { icon: '📦', title: 'Materiais prontos', desc: 'Banners, copys, emails e videos prontos para voce usar nas suas campanhas.' },
        { icon: '📊', title: 'Dashboard exclusivo', desc: 'Acompanhe cliques, conversoes e comissoes em tempo real no seu painel.' },
        { icon: '🎯', title: 'Produto que vende sozinho', desc: 'VSLBooster resolve uma dor real: conversao. Seu indicado vai agradecer.' },
        { icon: '💳', title: 'Pagamento pontual', desc: 'Receba via PIX ou transferencia todo dia 15, sem atrasos.' },
      ],
      steps: [
        { title: 'Cadastre-se', desc: 'Preencha o formulario abaixo. Aprovacao em ate 48h.' },
        { title: 'Receba seu link', desc: 'Link personalizado + materiais de divulgacao prontos.' },
        { title: 'Divulgue', desc: 'Compartilhe em redes sociais, email, grupos, blog, YouTube...' },
        { title: 'Receba comissoes', desc: '30% recorrente de cada venda. Todo mes no seu bolso.' },
      ],
      checks: [
        'Sem investimento inicial',
        'Comissao recorrente (nao apenas na 1a venda)',
        'Link de afiliado personalizado',
        'Suporte dedicado ao afiliado',
        'Materiais de divulgacao prontos',
      ],
      faqs: [
        { q: 'Preciso pagar algo para ser afiliado?', a: 'Nao. O programa e 100% gratuito. Voce nao paga nada para participar.' },
        { q: 'Quanto tempo demora para aprovar meu cadastro?', a: 'Ate 48 horas uteis. Voce recebera um email com a resposta.' },
        { q: 'A comissao e recorrente mesmo?', a: 'Sim! Voce recebe 30% de cada pagamento do seu indicado, todo mes, enquanto ele for assinante.' },
        { q: 'Preciso ser cliente para ser afiliado?', a: 'Nao e obrigatorio, mas recomendamos. Quem usa o produto consegue recomendar melhor.' },
        { q: 'Como recebo minhas comissoes?', a: 'Via PIX ou transferencia bancaria, todo dia 15 do mes seguinte.' },
        { q: 'Tem limite de indicacoes?', a: 'Nao! Quanto mais indicar, mais ganha. Sem teto de comissoes.' },
      ],
    }
  },
  methods: {
    api() { return (process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend').replace(/\/$/, '') },
    async submit() {
      this.erro = ''
      if (!this.form.name) { this.erro = 'Informe seu nome.'; return }
      if (!this.form.email) { this.erro = 'Informe seu email.'; return }
      if (!this.form.phone) { this.erro = 'Informe seu WhatsApp.'; return }

      this.loading = true
      try {
        const resp = await fetch(`${this.api()}/affiliate-signup`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ...this.form,
            page_url: window.location.href,
            utm_source: new URLSearchParams(window.location.search).get('utm_source'),
            utm_medium: new URLSearchParams(window.location.search).get('utm_medium'),
            utm_campaign: new URLSearchParams(window.location.search).get('utm_campaign'),
          }),
        })
        const data = await resp.json()
        if (resp.ok && data.id) {
          this.done = true
        } else {
          this.erro = data.error || 'Erro ao enviar. Tente novamente.'
        }
      } catch {
        this.erro = 'Falha na conexao. Tente novamente.'
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
$orange: #E86A10;
$navy: #0D1B2E;

.af { background: #fff; min-height: 100vh; font-family: 'Inter', -apple-system, sans-serif; }

/* ── Nav ─────────────────────────────────────────────────────── */
.af-nav { background: $navy; padding: 0 24px; }
.af-nav__inner { max-width: 1120px; margin: 0 auto; height: 68px; display: flex; align-items: center; justify-content: space-between; }
.af-nav__logo-img { height: 36px; }
.af-nav__links { display: flex; gap: 32px; }
.af-nav__link { color: rgba(255,255,255,0.8); font-size: 14px; font-weight: 500; text-decoration: none; &:hover { color: #fff; } }
.af-nav__actions { display: flex; gap: 12px; align-items: center; }
@media (max-width: 640px) { .af-nav__links { display: none; } }

/* ── Container ───────────────────────────────────────────────── */
.af-container { max-width: 1120px; margin: 0 auto; padding: 0 24px; }

/* ── Hero ────────────────────────────────────────────────────── */
.af-hero {
  background: linear-gradient(135deg, $navy 0%, #0a2240 60%, darken($orange, 5%) 100%);
  padding: 100px 24px 80px; text-align: center;
}
.af-hero__content { max-width: 780px; margin: 0 auto; }
.af-hero__badge {
  display: inline-block; padding: 7px 20px; border-radius: 20px;
  background: rgba(255,255,255,0.1); color: $orange; font-size: 13px;
  font-weight: 700; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 24px;
}
.af-hero__title { font-size: 3rem; font-weight: 900; color: #fff; line-height: 1.1; margin: 0 0 20px; letter-spacing: -1px; span { color: $orange; } }
@media (max-width: 768px) { .af-hero__title { font-size: 2rem; } }
.af-hero__sub { color: rgba(255,255,255,0.7); font-size: 1.15rem; line-height: 1.7; margin: 0 0 40px; }
.af-hero__stats { display: flex; justify-content: center; gap: 48px; flex-wrap: wrap; }
.af-hero__stat { text-align: center; }
.af-hero__stat-value { font-size: 2rem; font-weight: 900; color: $orange; }
.af-hero__stat-label { font-size: 13px; color: rgba(255,255,255,0.6); margin-top: 4px; }

/* ── Section title ───────────────────────────────────────────── */
.af-section-title { font-size: 1.8rem; font-weight: 900; color: #0f172a; text-align: center; margin: 0 0 40px; letter-spacing: -0.5px; }

/* ── Benefits ────────────────────────────────────────────────── */
.af-benefits { padding: 80px 24px; background: #f8fafc; }
.af-benefits__grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
@media (max-width: 768px) { .af-benefits__grid { grid-template-columns: 1fr; } }
.af-benefit {
  background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; padding: 28px;
  transition: all 0.2s; &:hover { box-shadow: 0 8px 24px rgba(0,0,0,0.06); transform: translateY(-2px); }
}
.af-benefit__icon { font-size: 28px; margin-bottom: 12px; }
.af-benefit__title { font-size: 1rem; font-weight: 800; color: #0f172a; margin: 0 0 8px; }
.af-benefit__desc { font-size: 0.88rem; color: #64748b; line-height: 1.65; margin: 0; }

/* ── How it works ────────────────────────────────────────────── */
.af-how { padding: 80px 24px; }
.af-how__steps { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; }
@media (max-width: 768px) { .af-how__steps { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 480px) { .af-how__steps { grid-template-columns: 1fr; } }
.af-step { text-align: center; }
.af-step__num {
  width: 48px; height: 48px; border-radius: 50%;
  background: linear-gradient(135deg, $orange, #F59E0B);
  color: #fff; font-size: 20px; font-weight: 900;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 16px;
}
.af-step__title { font-size: 1rem; font-weight: 800; color: #0f172a; margin: 0 0 8px; }
.af-step__desc { font-size: 0.88rem; color: #64748b; line-height: 1.6; }

/* ── Form section ────────────────────────────────────────────── */
.af-form-section { padding: 80px 24px; background: linear-gradient(180deg, #fff 0%, #f8fafc 100%); }
.af-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 56px; align-items: start; }
@media (max-width: 860px) { .af-form-grid { grid-template-columns: 1fr; } }
.af-form-info__title { font-size: 1.8rem; font-weight: 900; color: #0f172a; margin: 0 0 12px; }
.af-form-info__sub { font-size: 1rem; color: #64748b; line-height: 1.7; margin: 0 0 28px; }
.af-form-info__checks { display: flex; flex-direction: column; gap: 12px; }
.af-check { display: flex; align-items: center; gap: 10px; font-size: 14px; font-weight: 600; color: #1e293b; }
.af-check__icon { color: #10B981; font-weight: 800; }

.af-form-card {
  background: #fff; border: 1px solid #e2e8f0; border-radius: 20px;
  padding: 36px; box-shadow: 0 8px 32px rgba(0,0,0,0.06);
}

.af-field { margin-bottom: 16px; }
.af-label { display: block; font-size: 12px; font-weight: 700; color: #334155; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.3px; }
.af-optional { font-weight: 500; color: #94a3b8; text-transform: none; }
.af-input {
  width: 100%; padding: 12px 16px; border: 1.5px solid #e2e8f0; border-radius: 10px;
  font-size: 14px; color: #0f172a; background: #fff; outline: none;
  font-family: inherit; box-sizing: border-box;
  &:focus { border-color: $orange; box-shadow: 0 0 0 3px rgba($orange, 0.08); }
}
.af-textarea { resize: vertical; min-height: 80px; }
select.af-input { appearance: auto; }

.af-erro { background: #FEF2F2; border: 1px solid #FECACA; border-radius: 10px; padding: 12px 16px; color: #991B1B; font-size: 13px; margin-bottom: 14px; }

.af-btn {
  width: 100%; padding: 15px; background: $orange; color: #fff;
  border: none; border-radius: 10px; font-size: 16px; font-weight: 800;
  cursor: pointer; font-family: inherit; transition: all 0.2s;
  &:hover { opacity: 0.9; transform: translateY(-1px); box-shadow: 0 6px 20px rgba($orange, 0.3); }
  &:disabled { opacity: 0.5; cursor: not-allowed; transform: none; box-shadow: none; }
  &--ghost { background: #fff; color: $orange; border: 2px solid $orange; text-decoration: none; display: inline-block; text-align: center; padding: 12px 28px; width: auto; }
}

.af-privacy { font-size: 12px; color: #94a3b8; text-align: center; margin: 12px 0 0; }

.af-success { text-align: center; padding: 20px 0; }
.af-success__icon { font-size: 48px; margin-bottom: 16px; }
.af-success__title { font-size: 1.3rem; font-weight: 800; color: #0f172a; margin: 0 0 10px; }
.af-success__text { font-size: 0.95rem; color: #64748b; line-height: 1.7; margin: 0 0 20px; }

/* ── FAQ ─────────────────────────────────────────────────────── */
.af-faq { padding: 80px 24px; }
.af-faq__list { max-width: 720px; margin: 0 auto; }
.af-faq__item {
  border-bottom: 1px solid #e2e8f0; cursor: pointer;
  &:first-child { border-top: 1px solid #e2e8f0; }
}
.af-faq__q {
  display: flex; justify-content: space-between; align-items: center;
  padding: 20px 0; font-size: 15px; font-weight: 700; color: #0f172a;
}
.af-faq__arrow { font-size: 12px; color: #94a3b8; transition: transform 0.2s; &--open { transform: rotate(180deg); } }
.af-faq__a { padding: 0 0 20px; font-size: 14px; color: #64748b; line-height: 1.7; }

/* ── Footer ──────────────────────────────────────────────────── */
.af-footer { background: $navy; padding: 32px 24px; }
.af-footer__inner { display: flex; justify-content: space-between; align-items: center; color: rgba(255,255,255,0.5); font-size: 13px; flex-wrap: wrap; gap: 12px; }

// ── Mobile ──────────────────────────────────────────────────
@media (max-width: 640px) {
  .af-hero { padding: 80px 16px 48px; }
  .af-hero__title { font-size: 1.7rem; }
  .af-hero__sub { font-size: 0.95rem; }
  .af-hero__stats { gap: 24px; }
  .af-hero__stat-value { font-size: 1.5rem; }
  .af-section-title { font-size: 1.4rem; }
  .af-benefits, .af-how, .af-form-section, .af-faq { padding: 48px 16px; }
  .af-form-grid { gap: 28px; }
  .af-form-card { padding: 24px 18px; }
  .af-form-info__title { font-size: 1.4rem; }
  .af-nav__inner { padding: 0 16px; }
  .af-footer__inner { flex-direction: column; text-align: center; }
}
</style>
